import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// ============================================
// Privacy Notice Banner
// ============================================
import { useState, useEffect } from 'react';
const STORAGE_KEY = 'privacy_notice_accepted';
export function PrivacyNotice() {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        if (!localStorage.getItem(STORAGE_KEY)) {
            setVisible(true);
        }
    }, []);
    const accept = () => {
        localStorage.setItem(STORAGE_KEY, '1');
        setVisible(false);
    };
    if (!visible)
        return null;
    return (_jsx("div", { className: "fixed bottom-0 left-0 right-0 z-50 flex justify-center px-4 pb-4 md:pb-5 pointer-events-none", children: _jsxs("div", { className: "pointer-events-auto max-w-xl w-full bg-white border border-gray-200 rounded-2xl shadow-lg px-5 py-4 flex items-start gap-4", children: [_jsx("div", { className: "flex-1 min-w-0", children: _jsxs("p", { className: "text-[13px] text-gray-600 leading-relaxed", children: [_jsx("span", { className: "font-medium text-gray-800", children: "ParentalGrad" }), " stocke uniquement vos donn\u00E9es de session et vos pr\u00E9f\u00E9rences localement. Aucun cookie de tra\u00E7age ni publicit\u00E9 personnalis\u00E9e."] }) }), _jsx("button", { onClick: accept, className: "flex-shrink-0 px-4 py-1.5 bg-primary-400 hover:bg-primary-500 text-white text-[12.5px] font-medium rounded-xl transition-colors whitespace-nowrap", children: "OK, compris" })] }) }));
}
//# sourceMappingURL=PrivacyNotice.js.map